export default __webpack_public_path__ + "static/media/deathwhirlwind.c3be2311.png";